<script>
  import ListHeader from '../../../../app/components/list/Header.vue'
  import ListEmpty from '../../../../app/components/list/ListEmpty.vue'
  import SubmissionStatusLabel from './labels/StatusLabel'

  import * as restfulService from '../../../services/restfulService'
  import * as notifyService from '../../../services/notifyService'
  import DataService from '../../../services/dataService'

  import helperMixin from '../../../../mixins/helper'
  import bus from '@utils/bus'

  import {clone} from 'lodash'

  const defaultFilters = {event_id: '', dates: [], paper_status_id: []}

  export default {
    components: {ListHeader, ListEmpty, SubmissionStatusLabel},
    mixins: [helperMixin],
    data () {
      return {
        isLoadingData: true,
        filters: clone(defaultFilters),
        list: [],
        dependencies: {
          main_events: [],
          public_paper_status: []
        }
      }
    },
    computed: {
      papersListEmpty: function () {
        return this.list.every((item) => {
          return !item.papers || item.papers.length === 0
        })
      }
    },
    mounted () {
      this.getDependencies().then(() => {
        this.filters.paper_status_id = this.dependencies.public_paper_status.map(item => item.id)
        this.getPapers()
      })
    },
    methods: {
      getDependencies () {
        return new Promise(resolve => {
          DataService.get([{domain: 'main_event'}, {domain: 'public_paper_status'}]).then((result) => {
            this.dependencies = result
            resolve()
          })
        })
      },
      getPapers () {
        bus.$emit('show-loader')
        let data = this.getSearchData()
        restfulService.post('paper', 'my', null, data)
          .then((response) => {
            this.list = response
            this.isLoadingData = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.isLoadingData = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      },
      getSearchData () {
        const searchData = {}
        if (this.filters.event_id) {
          searchData.event_id = this.filters.event_id
        }
        if (this.filters.paper_status_id.length) {
          searchData.paper_status_id = this.filters.paper_status_id
        }
        if (this.filters.dates && this.filters.dates.length > 0) {
          let startDate = this.dateFormat(this.filters.dates[0], 'en')
          let endDate = this.dateFormat(this.filters.dates[1], 'en')
          if (startDate.length > 0 && endDate.length > 0) {
            searchData.start_date = startDate + ' 00:00:00'
            searchData.end_date = endDate + ' 23:59:59'
          } else if (startDate.length > 0 && endDate.length === 0) {
            searchData.start_date = startDate + ' 00:00:00'
            searchData.end_date = startDate + ' 23:59:59'
          } else if (startDate.length === 0 && endDate.length > 0) {
            searchData.start_date = endDate + ' 00:00:00'
            searchData.end_date = endDate + ' 23:59:59'
          }
        }
        return searchData
      },
      onFilter () {
        this.getPapers()
      },
      onFilterClean () {
        this.filters = clone(defaultFilters)
        this.filters.paper_status_id = this.dependencies.public_paper_status.map(item => item.id)
        this.getPapers()
      },
      editSubmission (paper) {
        if (paper.can_edit_or_delete) {
          this.$router.push({name: 'submission.show', params: {id: paper.id}})
        } else {
          notifyService.warning({
            hideLoader: true,
            title: 'Atenção',
            message: 'O período de edição das submissões já passou.'
          })
        }
      },
      deleteSubmission (paper) {
        bus.$emit('show-loader')
        restfulService.destroy('paper', null, paper.id)
          .then(_ => {
            notifyService.success({
              hideLoader: true,
              message: 'Seu trabalho foi removido'
            })
            this.getPapers()
          })
          .catch(e => {
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="custom-list">

        <h2>Submissões</h2>
        <h4 class="header-subtitle">Suas submissões</h4>

        <el-card class="el-card__search_list box-card">
            <div slot="header">
                <span>Filtrar Submissões</span>
                <div class="el-search-buttons">
                    <el-button type="primary" size="small" @click="onFilter">
                        <i class="fa fa-filter"></i>
                        <span>Aplicar Filtro</span>
                    </el-button>
                    <el-button type="default" size="small" @click="onFilterClean">Limpar</el-button>
                </div>
            </div>
            <el-form :inline="true" :model="filters" class="demo-form-inline">
                <div>
                    <el-form-item label="Evento Principal">
                        <el-select v-model="filters.event_id"
                                   filterable
                                   clearable
                                   placeholder="Filtrar Evento"
                                   empty-text="Nenhum registro encontrado">
                            <el-option v-for="item in dependencies.main_events"
                                       :key="item.id"
                                       :label="item.title"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Data da Submissão">
                        <el-date-picker
                                v-model="filters.dates"
                                type="daterange"
                                format="dd/MM/yyyy"
                                placeholder="Filtrar por data">
                        </el-date-picker>
                    </el-form-item>
                </div>
                <div>
                    <el-form-item label="Situação" style="width: 100%;">
                        <el-select v-model="filters.paper_status_id"
                                   filterable
                                   multiple
                                   clearable
                                   placeholder="Filtrar Situação"
                                   empty-text="Nenhum registro encontrado">
                            <el-option v-for="item in dependencies.public_paper_status"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form>
        </el-card>

        <div class="item-submission"
             v-if="!papersListEmpty"
             v-for="item in list">
            <div class="header">
                <strong>{{item.main_event.title}}</strong>
            </div>
            <div class="body">
                <div class="responsive-table">
                    <table class="custom-table-list">
                        <thead>
                        <tr>
                            <th>Evento</th>
                            <th>Tipo de Trabalho</th>
                            <th>Título</th>
                            <th>Data da Submissão</th>
                            <th>Situação</th>
                            <th>Ações</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="paper in item.papers">
                            <td>{{paper.event_paper_type.event.title}}</td>
                            <td>{{paper.event_paper_type.paper_type.name}}</td>
                            <td>{{paper.title ? paper.title.value : ''}}</td>
                            <td>{{paper.date_submitted | dateTimeEnToBr}}</td>
                            <td>
                                <div>
                                    <submission-status-label :status-key="paper.status.key"
                                                             :status-name="paper.status.public_name"/>
                                </div>
                                <div class="small">Última Atualização: {{paper.last_modified | dateTimeEnToBr }}</div>
                            </td>
                            <td>
                                <div class="table-btn-actions btn-3">
                                    <router-link :to="{ name: 'submission.show', params: { id: paper.id } }"
                                                 class="el-button el-button--info el-button--small"
                                                 title="Visualizar">
                                        <i class="fa fa-eye"></i>
                                    </router-link>
                                    <el-button type="success"
                                               size="small"
                                               @click="editSubmission(paper)"
                                               title="Editar">
                                        <i class="fa fa-edit"></i>
                                    </el-button>
                                    <el-button type="danger"
                                               size="small"
                                               v-if="paper.can_edit_or_delete"
                                               @click="deleteSubmission(paper)"
                                               title="Remover">
                                        <i class="fa fa-trash"></i>
                                    </el-button>
                                </div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <list-empty v-if="papersListEmpty"
                    description="Nenhuma submissão encontrada, verifique os filtros e tente novamente"/>
    </div>

</template>

<style lang="scss" scoped>
    .item-submission {
        border: 1px solid #dfe6ec;
        margin-bottom: 20px;

        .header {
            padding: 14px 20px;
            background: #f3f3f3;
            font-size: 18px;
        }

        .body {
            padding: 8px 12px;
            .custom-table-list {
                margin: 0;
                thead th {
                    padding: 6px 12px;
                }
            }
        }
    }
</style>
